import React, { useMemo } from 'react';
import { TypedMemo } from '../../../common/types';
import { AiVideoNotice } from '../aiNotice/AiVideoNotice';
import { useMediaContainsAiVideo } from '../aiNotice/useMediaContainsAiVideo';
import { PromoteMediaDraft } from '../draftStore';
import { SerializedSocialChannel, SocialPlatform } from '../types';
import { channelPostsThroughApi } from './settings/useComposerPlatformSettings';

interface ComposerAiNoticeProps {
  accountId: number;
  media: PromoteMediaDraft | undefined;
  /** The channels of the artist and the platforms that the post goes to. */
  channels: SerializedSocialChannel[];
  platforms: SocialPlatform[];
}

/**
 * The AI notice of the Composer: one fixed line under the attached media when the file holds
 * AI-generated footage. It shows nothing for every other file. No switch (owner decision 2026-10-13).
 */
const ComposerAiNoticeComponent: React.FC<ComposerAiNoticeProps> = ({ accountId, media, channels, platforms }) => {
  const containsAiVideo = useMediaContainsAiVideo({ accountId, media });
  const hasManualChannel = useMemo(
    () =>
      platforms.some((platform) => !channelPostsThroughApi(channels.find((channel) => channel.platform === platform))),
    [channels, platforms]
  );

  if (!containsAiVideo) {
    return null;
  }
  return <AiVideoNotice hasManualChannel={hasManualChannel} />;
};

export const ComposerAiNotice = TypedMemo(ComposerAiNoticeComponent);
